import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { DownloadIcon } from "../../../../assets";
import { getModelById } from "../../../services";
import { getQueryValue } from "../../../store/selectors";
import {
  downloadFile,
  getHighlightedExcerpts,
  handleClickNote,
  printContent,
  processDocumentText,
} from "../../../utils";
import { Pagewrapper } from "../../components";
import { ActionButton } from "../../components/global";
import NotesModal from "../../components/global/_notesModal";
import "./index.scss";

const ModelDetails = (props) => {
  const { id } = useParams();

  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showNoteModal, setShowNoteModal] = useState(false);
  const [noteContent, setNoteContent] = useState("");
  const [noteTitle, setNoteTitle] = useState("");
  const [modalType, setModalType] = useState("note");
  const [articleId, setArticleId] = useState("");

  const query = useSelector(getQueryValue);

  const handleDownloadFile = () => {
    const wordUrl = `https://produtos.lex.com.br${model.versaoWord}`;

    downloadFile({
      name: model.titulo || "arquivo.docx",
      url: wordUrl,
    });
  };

  const handlePrint = () =>
    printContent({
      text: model?.texto,
      title: model?.titulo,
    });

  useEffect(() => {
    const loadModel = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getModelById(id);

        if (response && response.texto) {
          response.texto = processDocumentText({ htmlText: response.texto });
        }

        setModel(response);
      } catch (err) {
        setError(
          err.response?.data?.message || "Não foi possível encontrar o modelo"
        );
        console.error("Erro:", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadModel();
    }
  }, [id]);

  useEffect(() => {
    const handleGlobalClick = (event) => {
      const target = event.target;
      if (showNoteModal) return;

      if (target.classList?.contains("nota-super")) {
        handleClickNote(event);
        return;
      }

      if (target.tagName?.toLowerCase() === "a") {
        const href = target.getAttribute("href") || "";

        const match = href.match(/(art\d+)/i);

        if (match) {
          event.preventDefault();

          const articlePart = match[1];

          let cleaned = href.replace(/^\/?legislacao\//i, "");
          cleaned = cleaned.split("#")[0];

          if (!cleaned.toLowerCase().endsWith(articlePart.toLowerCase())) {
            cleaned = cleaned.replace(/art\d+/i, "") + articlePart;
          }

          setArticleId(cleaned);
          setModalType("legislation");
          setShowNoteModal(true);

          return;
        }
      }
    };

    document.addEventListener("click", handleGlobalClick);
    return () => document.removeEventListener("click", handleGlobalClick);
  }, [model, showNoteModal]);

  if (loading) {
    return (
      <Pagewrapper {...props}>
        <Container>
          <Row>
            <Col>
              <div className="content-loading">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-3">Carregando modelo...</p>
              </div>
            </Col>
          </Row>
        </Container>
      </Pagewrapper>
    );
  }

  if (error) {
    return (
      <Pagewrapper {...props}>
        <Container>
          <Row>
            <Col>
              <div className="error-section text-center">
                <h4 className="text-danger">
                  Ops! Parece que ocorreu um erro.
                </h4>
                <p>{error}</p>
                <small className="text-muted">Modelo: {id}</small>
              </div>
            </Col>
          </Row>
        </Container>
      </Pagewrapper>
    );
  }

  return (
    <Pagewrapper {...props}>
      <Container>
        <Row>
          <Col>
            <div className="mt-4">
              <div className="content-header">
                <div className="content-actions d-flex justify-content-end gap-2">
                  <ActionButton
                    icon={<BookmarkBorderOutlinedIcon fontSize="small" />}
                    onClick={() => {
                      try {
                        if (window.external && window.external.AddFavorite) {
                          window.external.AddFavorite(
                            window.location.href,
                            document.title
                          );
                        } else if (window.sidebar && window.sidebar.addPanel) {
                          window.sidebar.addPanel(
                            document.title,
                            window.location.href,
                            ""
                          );
                        } else {
                          const isMac =
                            navigator.platform.toUpperCase().indexOf("MAC") >=
                            0;
                          const shortcut = isMac ? "Cmd+D" : "Ctrl+D";
                          alert(
                            `Para adicionar aos favoritos, pressione ${shortcut} ou use o menu do seu navegador.`
                          );
                        }
                      } catch (error) {
                        console.error(
                          "Erro ao tentar adicionar aos favoritos:",
                          error
                        );
                        const isMac =
                          navigator.platform.toUpperCase().indexOf("MAC") >= 0;
                        const shortcut = isMac ? "Cmd+D" : "Ctrl+D";
                        alert(
                          `Para adicionar aos favoritos, pressione ${shortcut} ou use o menu do seu navegador.`
                        );
                      }
                    }}
                    label="    Salvar"
                  />

                  <ActionButton
                    icon={<PrintOutlinedIcon fontSize="small" />}
                    label="   Imprimir"
                    onClick={handlePrint}
                  />
                  <ActionButton
                    icon={<DownloadIcon />}
                    label="Baixar em Word"
                    onClick={handleDownloadFile}
                  />
                </div>
              </div>

              <div className="content-box">
                {model?.texto ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: !!query
                        ? getHighlightedExcerpts(
                            model.texto,
                            query,
                            model.texto.length,
                            false
                          )
                        : model.texto,
                    }}
                    className="content-text"
                  />
                ) : (
                  <p className="text-muted">Conteúdo não disponível.</p>
                )}
              </div>
            </div>
          </Col>
          <NotesModal
            noteContent={noteContent}
            noteTitle={noteTitle}
            setShowNoteModal={setShowNoteModal}
            showNoteModal={showNoteModal}
            type={modalType}
            articleId={articleId}
          />
        </Row>
      </Container>
    </Pagewrapper>
  );
};

export default ModelDetails;
